import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";

// Matches the value type returned by queryString.parse (a single param can be
// string, an array of nullable strings for repeated keys, or null when absent).
type QueryParamValue = string | (string | null)[] | null;

interface UseFindingsQueryParamReturn {
  param: QueryParamValue;
  search: string;
  clearQueryParam: (paramTypes: string[]) => void;
}

const useFindingsQueryParam = (
  queryParam: string | null
): UseFindingsQueryParamReturn => {
  const location = useLocation();
  const { search } = location;
  const history = useHistory();
  const [param, setParam] = useState<QueryParamValue>(null);

  const setStateByQueryParams = () => {
    const queryStringObj = queryString.parse(search);
    queryStringObj[queryParam as string]
      ? setParam(queryStringObj[queryParam as string])
      : setParam(null);
  };

  useEffect(() => {
    if (!!search) {
      setStateByQueryParams();
    } else if (!search && !!param) {
      setParam(null);
    }
  }, [search]);

  const clearQueryParam = (paramTypes: string[]) => {
    const queryObj = queryString.parse(search);

    for (let i = 0; i < paramTypes.length; i++) {
      delete queryObj[paramTypes[i]];
      history.replace({ search: queryString.stringify(queryObj) });
    }
  };

  return {
    param,
    search,
    clearQueryParam,
  };
};

export default useFindingsQueryParam;
